import { configType, EnvironmentLevelKeys } from "./environmentConfigs/configTypes"

const sentryEnv = ['NCSTEST','PRODUCTION']

const ENV : EnvironmentLevelKeys  = "PRODUCTION"

const configs: configType = {
  apiKey: "b92307c2-1a60-4d4b-b1fe-4d3ba57d1ca5",
  logLevel: 1,
  environmentLevel: ENV,
  sentryEnable: sentryEnv.includes(ENV) ? true : false
}

export default configs
  